module.exports = __webpack_public_path__ + "assets/img/zhuanjia_ft.f5a87bf8.png";